// Krenz绘画笔记PDF文件配置
export const krenzPDFs = {
  'perspective-structure-11': {
    name: '基础透视与结构11期',
    folder: 'perspective-structure-11',
    pdfs: [
      { name: '08/05/2022', file: '01.pdf' },
      { name: '08/12/2022', file: '02.pdf' },
      { name: '08/19/2022', file: '03.pdf' },
      { name: '08/26/2022', file: '04.pdf' },
      { name: '09/02/2022', file: '05.pdf' },
      { name: '09/09/2022', file: '06.pdf' },
      { name: '09/16/2022', file: '07.pdf' },
      { name: '09/23/2022', file: '08.pdf' },
    ],
  },
  'color-light-11': {
    name: '色彩与光影11期',
    folder: 'color-light-11',
    pdfs: [
      { name: '10/15/2022', file: '01.pdf' },
      { name: '10/22/2022', file: '02.pdf' },
      { name: '10/29/2022', file: '03.pdf' },
      { name: '11/05/2022', file: '04.pdf' },
      { name: '11/12/2022', file: '05.pdf' },
      { name: '11/19/2022', file: '06.pdf' },
      { name: '11/26/2022', file: '07.pdf' },
      { name: '12/03/2022', file: '08.pdf' },
    ],
  },
  'dynamic-composition-10': {
    name: '动态与构成10期',
    folder: 'dynamic-composition-10',
    pdfs: [
      { name: '04/28/2023', file: '01.pdf' },
      { name: '05/05/2023', file: '02.pdf' },
      { name: '05/12/2023', file: '03.pdf' },
      { name: '05/19/2023', file: '04.pdf' },
      { name: '05/26/2023', file: '05.pdf' },
    ],
  },
}

// 获取PDF完整路径的辅助函数
export const getPDFPath = (folder, filename) => {
  return `/pdfs/krenz-notes/${folder}/${filename}`
}
